import React from "react";
import Loader from "../../Common/Loader";

function TermlyFeeInvoicesCount({termlyFeeCount, loading}) {
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const todayFormatted = new Date().toLocaleDateString('en-US', options);

    return (
        <div className="col-lg-12">
            <div className="card custom-card" style={{paddingBottom:"10px"}}>
            <div className="card-body map-card">
                <div className="item-title">
                <h5 style={{marginBottom:10}}>Termly Fees Today ({todayFormatted})</h5>
                </div>
                {loading ?(
                  <Loader/>
                ) : (
                <table className="table mb-0 color-span">
                <thead>
                <tr>
                <th className="w-50">School</th>
                <th></th>
                <th className="py-2 px-0" scope="col">No.</th>
                <th className="py-2 px-0" scope="col">Total (UGX.)</th>

                </tr>
                </thead>
                <tbody style={{fontSize:"14px"}}>
        {Array.isArray(termlyFeeCount) && termlyFeeCount.map((item, key) => (
                                                <tr key={key}>
          <td className="py-2 px-0">
            <span className="w-50">{item.school_name}</span>
          </td>
          <td>:</td>
          <td className="py-2 px-0">
            <span className="">
            {item.invoice_count? item.invoice_count?.total_c:"..."}
            </span>
          </td>
          <td className="py-2 px-0">
            <span className="">
            UGX. {item.amount_paid? item.amount_paid?.total_c:"..."}
            </span>
          </td>
        </tr>
                                            ))}
                                            {termlyFeeCount === "404" && (<tr>
                                                <td colSpan="3" style={{textAlign: "center"}}>
                                                    No termly fees collected today.
                                                </td>
                                            </tr>)}
       
              </tbody>
                </table>)}
            </div>
            </div>
        </div>
        
    );
}

export default TermlyFeeInvoicesCount;
